import { ReportTab } from '../models/ui/report-tab.model';

export class ReportsConstants {

	// Tab copy for the Financial Reports page — the description renders as help text under the
	// tab strip and is the active tab's accessible description. (DEV-2703)
	static readonly REPORT_TABS: ReportTab[] = [
		{
			path: 'trial-balance',
			label: 'Trial Balance',
			icon: 'scale-balanced',
			description: "Every ledger account and its balance as of a date — used to confirm the books' balance."
		},
		{
			path: 'balance-sheet',
			label: 'Balance Sheet',
			icon: 'file-invoice-dollar',
			description: 'What your organization owns and owes as of a single date.'
		},
		{
			path: 'income-statement',
			label: 'Income Statement',
			icon: 'chart-line',
			description: 'Income and expenses over a date range. Also called a Profit & Loss (P&L).'
		}
	];
}
